import { mapGetters } from 'vuex'
import BUSINESS_SLUGS, { BUSINESS_FEATURES } from '@/constants/business-types'

const BusinessTypeMixin = {
  data() {
    return {
      BUSINESS_SLUGS,
      BUSINESS_FEATURES,
    }
  },
  computed: {
    ...mapGetters({
      isBusinessFeatureEnabled: 'businessTypes/isEnabled',
      dineInLabel: 'businessTypes/dineInLabel',
      isProductService: 'businessTypes/isProductService',
      dineInTranslationPath: 'businessTypes/dineInTranslationPath',
      tableLabelPath: 'businessTypes/tableLabelPath',
      floorLabelPath: 'businessTypes/floorLabelPath',
    }),
    tableLabel() {
      return count => this.$tc(this.tableLabelPath, count)
    },
    floorLabel() {
      return count => this.$tc(this.floorLabelPath, count)
    },
  },
}

export default BusinessTypeMixin
